/**A Hook that returns an object containing MUI SX functions or objects. Functions take theme as a parameter and return an object.
 *
 * @returns {object}
 */
const useStyles = () => {
    const instructionSx = theme=> {
        return {
            '&#instructions': {
                display: 'flex',
                flexDirection: 'column',
                gap: theme.spacing(1),
                mt: theme.spacing(2),
                mb: theme.spacing(3),
            }
        };
    };

    const contentBoxSx = theme=> {
        return {
            minHeight: theme.spacing(40),
        };
    };

    const blueTextSx = theme => {
        return {
            color: theme.palette.primary.main,
            fontWeight: 500,
        };
    };

    return {
        instructionSx,
        contentBoxSx,
        blueTextSx,
    };
};

export default useStyles;

